<template>
  <v-app v-if="loading">
    <v-container
      fluid
      fill-height
      class="loading-wrapper"
      style="animation-duration: 0.2s"
    >
      <v-row align="center" justify="center">
        <v-progress-circular
          indeterminate
          color="primary"
          width="2"
          size="40"
        ></v-progress-circular>
      </v-row>
    </v-container>
  </v-app>
  <v-app v-else :key="companyId">
    <feature name="projects" variant="write" data="projects">
      <navigation-drawer></navigation-drawer>
    </feature>
    <v-main class="main-bg">
      <v-layout>
        <router-view></router-view>
        <file-upload-toast></file-upload-toast>
      </v-layout>
    </v-main>
    <v-snackbar
      bottom
      right
      tile
      :multi-line="true"
      :value="updateExists"
      :timeout="-1"
      id="app-update"
    >
      <v-row align="center" class="ma-0 pa-0">
        <span class="text-body-light">An update is available</span>
        <v-btn class="button" text @click="refreshApp" color="red"
          >Update</v-btn
        >
      </v-row>
    </v-snackbar>
  </v-app>
</template>

<script>
// import AppBar from "@/components/AppBar.vue";
import NavigationDrawer from '@/components/NavigationDrawer.vue'
import { mapActions, mapGetters, mapState } from 'vuex'
import FileUploadToast from '@/components/FileUploadToast.vue'
import update from '../mixins/update'

export default {
  name: 'AppContainer',
  mixins: [update],
  components: {
    // AppBar,
    NavigationDrawer,
    FileUploadToast,
  },

  methods: {
    ...mapActions([
      'getInventoryCategories',
      'getLocations',
      'getClickworkProducts',
    ]),
  },
  computed: {
    ...mapGetters(['userScopes', 'companyId']),
    ...mapState(['appLoading']),
    loading() {
      return !this.userScopes || this.appLoading
    },
  },
  mounted() {
    this.getInventoryCategories()
    this.getLocations()
    this.getClickworkProducts()
  },
}
</script>

<style lang="sass" scoped>
.main-bg
  background: #f7f7f7

.loading-wrapper
  background: $secondary
  position: fixed
  width: 100%
  height: 100%
  left: 0
  right: 0
</style>

<style lang="sass">
#app-update > .v-snack__wrapper
  margin-right: 80px
  min-width: 100px
  &> .v-snack__content
    padding-right: 0
</style>